import React from 'react'

import PL7Wine from "../WineLayouts/PL7Wine"
import PL9Wine from "../WineLayouts/PL9Wine"
import PL5Wine from "../WineLayouts/PL5Wine"
import PL4Wine from '../WineLayouts/PL4Wine'
import PL1Wine from '../WineLayouts/PL1Wine'
import PL6Wine from '../WineLayouts/PL6Wine'
import PL8Wine from '../WineLayouts/PL8Wine'
import PL3Wine from '../WineLayouts/PL3Wine'
import PL2Wine from '../WineLayouts/PL2Wine'

const WineLocationRouter = (props) => {
    let location = props.location
    
    if (location === "pl7"){
        return (
            <PL7Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}

            />
        )
    } else if (location === 'pl2'){
        return (
            <PL2Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )
    }
    else if (location === 'pl1'){
        return (
            <PL1Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )

    }else if (location === "pl9"){
        return (
            <PL9Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )
    } else if (location === "pl5"){

        return (
            <PL5Wine
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )

    } else if (location === "pl4") {
        return (
            <PL4Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )
    } else if (location === "pl6") {
        return (
            <PL6Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )
    } else if (location === 'pl8') {
        return (
            <PL8Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
            />
        )
    } else if (location === 'pl3') {
           return ( <PL3Wine 
                whiteWine={props.whiteWineMenu}
                redWine={props.redWineMenu}
                filterPrice={props.filterPrice}
                filterPriceName={props.filterPriceName}
                orderWinePrices={props.orderWinePrices}
          
            
            />
            )
    } else {
        return ('loading...')
    }
}
export default WineLocationRouter